// extracted by mini-css-extract-plugin
export default {"container":"_1X5TY","button":"h47-d","icon":"_9UW1O","text":"qWLFh","title":"K6bx1","info":"mJABf"};